module.exports = __webpack_public_path__ + "static/flags/WS-84e5f31e46cd4fa1937cf2389dd7bc85.gif";